let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g3Naz")).then(() => parcelRequire('5fZdl'));